import { render } from "./Term.vue?vue&type=template&id=a98be2da&scoped=true"
import script from "./Term.vue?vue&type=script&lang=js"
export * from "./Term.vue?vue&type=script&lang=js"

import "./Term.vue?vue&type=style&index=0&id=a98be2da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a98be2da"]])

export default __exports__